<template>
  <div
    class="grid cursor-pointer grid-cols-1 place-content-start content-between overflow-hidden rounded-lg px-4 py-5 sm:p-6"
    :class="
      readonly
        ? 'hover:border-1 bg-neutral-99 hover:border-neutral-80 hover:bg-neutral-95'
        : 'border border-solid border-neutral-80 bg-white  hover:border-primary-40 hover:shadow '
    "
    @click="emitValue"
  >
    <div>
      <div
        :class="readonly ? 'text-neutral-20' : 'text-primary-60'"
        class="text-base font-medium leading-6"
        v-html="highlightedTitle"
      />

      <div class="mt-2 text-sm font-normal leading-5 text-neutral-40" v-html="highlightedDescription" />
    </div>

    <div class="mt-6">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { toRegex } from "diacritic-regex";

// Props
const props = withDefaults(
  defineProps<{
    title: string;
    description: string;
    highlightKeyword?: string;
    readonly?: boolean;
  }>(),
  {
    title: "",
    description: "",
    highlightKeyword: "",
    readonly: false,
  },
);

// Emits
const emit = defineEmits<{
  (e: "actionClick"): void;
}>();

const emitValue = () => {
  emit("actionClick");
};

const highlight = (text: string, keyword: string) =>
  text.replace(toRegex({ flags: "gi" })(keyword), (match: string) => {
    return '<span class="bg-primary-95">' + match + "</span>";
  });

const highlightedTitle = computed(() =>
  props.highlightKeyword ? highlight(props.title, props.highlightKeyword) : props.title,
);

const highlightedDescription = computed(() =>
  props.highlightKeyword ? highlight(props.description, props.highlightKeyword) : props.description,
);
</script>
